<template>
    <div class="com-targets-progress_page">
        <div class="flex-ac flex-sb valid-area m-b-16">
            <span class="mod-title f7"
                >{{ curCompany.name }}业绩<span class="fs12">（{{ globalYearMonth }}_不含税）</span></span
            >
            <div class="fixed-rt">
                <el-button-group>
                    <el-button size="mini" @click="fetchPageTypeData('month')" :type="dateType === 'month' ? 'primary' : ''">本月</el-button>
                    <el-button size="mini" @click="fetchPageTypeData('season')" :type="dateType === 'season' ? 'primary' : ''">本季</el-button>
                    <el-button size="mini" @click="fetchPageTypeData('year')" :type="dateType === 'year' ? 'primary' : ''">本年</el-button>
                    <el-button size="mini" @click="fetchPageTypeData('sum')" :type="dateType === 'sum' ? 'primary' : ''">累计</el-button>
                </el-button-group>
            </div>
        </div>
        <div class="dis-data valid-area" v-loading="loading">
            <div class="flex-sb flex-wrap m-b-20">
                <div class="com-data-item orange can-click">
                    <div class="fs16 f7 m-b-28">销售数据</div>
                    <Progress :value="monthSaleInfo.saleRate" type="orange"></Progress>
                    <div class="dis-info-box flex-ac flex-wrap">
                        <div class="data-row flex-ac m-b-20">
                            <div class="label gray80">预算</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.saleBudget | moneyFormat }}</span
                                ><span>{{ monthSaleInfo.saleBudget_unit }}</span>
                            </div>
                        </div>
                        <div class="data-row flex-ac f7 m-b-20">
                            <div class="label">实际完成</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.saleMoney | moneyFormat }}</span
                                    ><span>{{ monthSaleInfo.saleMoney_unit }}</span>
                            </div>
                        </div>
                        <div class="data-row flex-ac m-b-20">
                            <div class="label gray80">同比</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.xstb }}</span
                                ><span class="m-r-4">%</span>
                                <i class="el-icon-top hlg-red" v-if="monthSaleInfo.xstb_trend === 'rise'"></i>
                                <i class="el-icon-bottom hlg-green" v-else-if="monthSaleInfo.xstb_trend === 'down'"></i>
                                <i class="el-icon-minus" v-else></i>
                            </div>
                        </div>
                        <div class="data-row flex-ac m-b-20">
                            <div class="label gray80">自营收入</div>
                            <div class="gray66 fs16">
                                <span>{{ monthZyInfo.saleMoney | moneyFormat }}</span
                                ><span>{{ monthZyInfo.saleMoney_unit }}</span>
                            </div>
                        </div>
                        <!-- <div class="data-row flex-ac">
                            <div class="label gray80">服务收入</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.serviceMoney | moneyFormat }}</span
                                ><span>{{ monthSaleInfo.serviceMoney_unit }}</span>
                            </div>
                        </div>
                        <div class="data-row flex-ac">
                            <div class="label gray80">服务收入占比</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.serviceRate }}</span
                                ><span>%</span>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="com-data-item blue can-click">
                    <div class="fs16 f7 m-b-28">毛利数据</div>
                    <Progress :value="monthMlInfo.mlRate" type="blue"></Progress>
                    <div class="dis-info-box flex-ac flex-wrap">
                        <div class="data-row flex-ac m-b-20">
                            <div class="label gray80">预算</div>
                            <div class="gray66 fs16">
                                <span>{{ monthMlInfo.profitBudget | moneyFormat }}</span
                                ><span>{{ monthMlInfo.profitBudget_unit }}</span>
                            </div>
                        </div>
                        <div class="data-row flex-ac f7 m-b-20">
                            <div class="label">实际完成</div>
                            <div class="gray66 fs16">
                                <span>{{ monthMlInfo.mlMoney | moneyFormat }}</span
                                    ><span>{{ monthMlInfo.mlMoney_unit }}</span>
                            </div>
                        </div>
                        <div class="data-row flex-ac m-b-20">
                            <div class="label gray80">同比</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.mltb }}</span
                                ><span class="m-r-4">%</span>
                                <i class="el-icon-top hlg-red" v-if="monthSaleInfo.mltb_trend === 'rise'"></i>
                                <i class="el-icon-bottom hlg-green" v-else-if="monthSaleInfo.mltb_trend === 'down'"></i>
                                <i class="el-icon-minus" v-else></i>
                            </div>
                        </div>
                        <div class="data-row flex-ac m-b-20">
                            <div class="label gray80">毛利率</div>
                            <div class="gray66 fs16">
                                <span>{{ monthSaleInfo.mll }}</span
                                ><span>‰</span>
                            </div>
                        </div>
                        <!-- <div class="data-row flex-ac">
                            <div class="label gray80">正毛利</div>
                            <div class="gray66 fs16">
                                <span>{{ monthMlInfo.z_mlMoney | moneyFormat }}</span
                                ><span>{{ monthMlInfo.z_mlMoney_unit }}</span>
                            </div>
                        </div>
                        <div class="data-row flex-ac">
                            <div class="label gray80">负毛利</div>
                            <div class="gray66 fs16">
                                <span>{{ monthMlInfo.f_mlMoney | moneyFormat }}</span
                                ><span>{{ monthMlInfo.f_mlMoney_unit }}</span>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <!-- 预付、应收相关，因数据准确性问题暂时停用 -->
            <!-- <div class="flex-sb flex-wrap m-b-20">
                <div class="com-data-item can-click">
                    <div class="fs16 f7 m-b-16">预付账款</div>
                    <div class="zj-data purple flex-ac m-b-16">
                        <div class="fs16 m-r-32">本期变动</div>
                        <div class="fs24 m-r-4">{{ companyZjData.yf_change | moneyFormat }}</div>
                        <div>{{ companyZjData.yf_change_unit }}</div>
                    </div>
                    <div class="flex-ac fs16">
                        <div class="flex-ac flex-1">
                            <div class="gray99 m-r-32">期初</div>
                            <div class="m-r-4">{{ companyZjData.yf_qc | moneyFormat }}</div>
                            <div class="fs14">{{ companyZjData.yf_qc_unit }}</div>
                        </div>
                        <div class="flex-ac flex-1">
                            <div class="gray99 m-r-32">期末</div>
                            <div class="m-r-4">{{ companyZjData.yf_qm | moneyFormat }}</div>
                            <div class="fs14">{{ companyZjData.yf_qm_unit }}</div>
                        </div>
                    </div>
                </div>
                <div class="com-data-item orange can-click">
                    <div class="fs16 f7 m-b-16">应收账款</div>
                    <div class="zj-data yellow flex-ac m-b-16">
                        <div class="fs16 m-r-32">本期变动</div>
                        <div class="fs24 m-r-4">{{ companyZjData.ys_change | moneyFormat }}</div>
                        <div>{{ companyZjData.ys_change_unit }}</div>
                    </div>
                    <div class="flex-ac fs16">
                        <div class="flex-ac flex-1">
                            <div class="gray99 m-r-32">期初</div>
                            <div class="m-r-4">{{ companyZjData.ys_qc | moneyFormat }}</div>
                            <div class="fs14">{{ companyZjData.ys_qc_unit }}</div>
                        </div>
                        <div class="flex-ac flex-1">
                            <div class="gray99 m-r-32">期末</div>
                            <div class="m-r-4">{{ companyZjData.ys_qm | moneyFormat }}</div>
                            <div class="fs14">{{ companyZjData.ys_qm_unit }}</div>
                        </div>
                    </div>
                </div>
            </div> -->
            <div class="flex-sb flex-wrap m-b-40">
                <div class="com-data-item small">
                    <div class="flex-ac m-b-40">
                        <img class="icon" src="../../../assets/img/pic-1.png" alt="">
                        <span class="fs16 f7">财务收入</span>
                    </div>
                    <div class="flex-ac">
                        <div class="col-half">
                            <div class="m-b-10">
                                <span class="val fs20">{{ cwsrInfo.cdtx_money | moneyFormat }}</span
                                ><span class="fs14">{{ cwsrInfo.cdtx_money_unit }}</span>
                            </div>
                            <div class="label">承兑贴现</div>
                        </div>
                        <div class="col-half">
                            <div class="m-b-10">
                                <span class="val fs20">{{ cwsrInfo.lxsr_money | moneyFormat }}</span
                                ><span class="fs14">{{ cwsrInfo.lxsr_money_unit }}</span>
                            </div>
                            <div class="label">利息收入</div>
                        </div>
                    </div>
                </div>
                <div class="com-data-item small">
                    <div class="flex-ac m-b-40">
                        <img class="icon" src="../../../assets/img/pic-2.png" alt="">
                        <span class="fs16 f7">经营数据</span>
                    </div>
                    <div class="flex-ac">
                        <div class="col-half">
                            <div class="m-b-10">
                                <span class="val fs20">{{ jYCostInfo.jyProfit | moneyFormat }}</span
                                ><span class="fs14">{{ jYCostInfo.jyProfit_unit }}</span>
                            </div>
                            <div class="label">经营利润</div>
                        </div>
                        <div class="col-half">
                            <div class="m-b-10">
                                <span class="val fs20">{{ jYCostInfo.serviceMoneyTotal | moneyFormat }}</span
                                ><span class="fs14">{{ jYCostInfo.serviceMoneyTotal_unit }}</span>
                            </div>
                            <el-tooltip placement="bottom" >
                                <div slot="content">
                                    <div :class="{'m-b-10': index<jYCostInfo.jYCostList.length-1}" v-for="(item,index) in jYCostInfo.jYCostList" :key="item.sort">{{ item.serviceTypeName }}：{{ item.serviceMoney | moneyFormat }}{{ item.serviceMoney_unit }}</div>
                                </div>
                                <div class="label"><span class="m-r-4">经营费用</span><i class="el-icon-warning-outline f12 hlg-red"></i></div>
                            </el-tooltip>
                        </div>
                    </div>
                </div>
                <div class="com-data-item small can-click">
                    <div class="flex-ac m-b-40">
                        <img class="icon" src="../../../assets/img/pic-3.png" alt="">
                        <span class="fs16 f7">纳税数据</span>
                    </div>
                    <div class="flex-ac">
                        <div class="col-1">
                            <div class="m-b-10">
                                <span class="val fs20">{{ taxMap.total_tax | moneyFormat }}</span
                                ><span class="fs14">{{ taxMap.total_tax_unit }}</span>
                            </div>
                            <div class="label">纳税金额</div>
                        </div>
                        <div class="col-2">
                            <div class="m-b-10">
                                <span class="val fs20">{{ taxMap.total_yh_tax | moneyFormat }}</span
                                ><span class="fs14">{{ taxMap.total_yh_tax_unit }}</span>
                            </div>
                            <el-tooltip placement="bottom" >
                                <div slot="content">
                                    <div class="m-b-10">采购印花税：{{ taxMap.cg_yh_tax | moneyFormat }}{{ taxMap.cg_yh_tax_unit }}</div>
                                    <div>销售印花税：{{ taxMap.xs_yh_tax | moneyFormat }}{{ taxMap.xs_yh_tax_unit }}</div>
                                </div>
                                <div class="label"><span class="m-r-4">印花税</span><i class="el-icon-warning-outline f12 hlg-red"></i></div>
                            </el-tooltip>
                        </div>
                        <div class="col-3">
                            <div class="m-b-10">
                                <span class="val fs20">{{ taxMap.fj_tax | moneyFormat }}</span
                                ><span class="fs14">{{ taxMap.fj_tax_unit }}</span>
                            </div>
                            <div class="label">附加税</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="valid-area m-b-40">
            <div class="m-b-16 flex-ac flex-sb">
                <span class="mod-title f7"
                    >部门销售数据<span class="fs14">（{{ globalYearMonth }}_不含税_单位万）</span></span
                >
            </div>
            <div class="table-mod">
                <el-table
                    v-loading="deptLoading"
                    :data="deptDataInfo"
                    border
                    style="width: 100%;font-size: 14px"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ color: '#3D4EFF',background: '#ffffff' }"
                >
                    <el-table-column prop="Name" label="部门名称">
                        <span class="f7" slot-scope="scope">{{ scope.row.deptName }}</span>
                    </el-table-column>
                    <el-table-column prop="saleMoney" label="销售" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.saleMoney | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="mlMoney" label="总毛利">
                        <span class="f7" slot-scope="scope">{{ scope.row.mlMoney | moneyFormat }}</span>
                    </el-table-column>
                    <!-- <el-table-column prop="z_mlMoney" label="正毛利">
                        <span class="f7" slot-scope="scope">{{ scope.row.z_mlMoney | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="f_mlMoney" label="负毛利">
                        <span class="f7" slot-scope="scope">{{ scope.row.f_mlMoney | moneyFormat }}</span>
                    </el-table-column> -->
                </el-table>
            </div>
            <div class="m-b-16 flex-ac flex-sb">
                <span class="mod-title f7"
                    >合作商销售数据<span class="fs14">（{{ globalYearMonth }}_不含税_单位万）</span></span
                >
            </div>
            <div class="table-mod">
                <el-table
                    v-loading="parLoading"
                    :data="parDataInfo"
                    border
                    style="width: 100%;font-size: 14px"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ color: '#3D4EFF',background: '#ffffff' }"
                >
                    <el-table-column prop="partnerName" label="合作商名称">
                        <span class="f7" slot-scope="scope">{{ scope.row.partnerName }}</span>
                    </el-table-column>
                    <el-table-column prop="saleMoney" label="销售" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.saleMoney | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="mlMoney" label="总毛利">
                        <span class="f7" slot-scope="scope">{{ scope.row.mlMoney | moneyFormat }}</span>
                    </el-table-column>
                    <!-- <el-table-column prop="z_mlMoney" label="正毛利">
                        <span class="f7" slot-scope="scope">{{ scope.row.z_mlMoney | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="f_mlMoney" label="负毛利">
                        <span class="f7" slot-scope="scope">{{ scope.row.f_mlMoney | moneyFormat }}</span>
                    </el-table-column> -->
                </el-table>
            </div>
            <!-- 预付、应收相关，因数据准确性问题暂时停用 -->
            <!-- <div class="m-b-16 flex-ac flex-sb">
                <span class="mod-title f7"
                    >合作商预付账款<span class="fs14">（{{ globalYearMonth }}_单位万）</span></span
                >
            </div>
            <div class="table-mod">
                <el-table
                    v-loading="partnerZjYfLoading"
                    :data="partnerZjYfInfo"
                    border
                    style="width: 100%;font-size: 14px"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ color: '#3D4EFF',background: '#ffffff' }"
                    @row-click="row => ysyfRowClick('partner','yf',row.partnerName)"
                >
                    <el-table-column prop="partnerName" label="合作商名称" width="200">
                        <span class="f7" slot-scope="scope">{{ scope.row.partnerName }}</span>
                    </el-table-column>
                    <el-table-column prop="yf_qc" label="期初" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.yf_qc | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="yf_change" label="本期变动" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.yf_change | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="yf_qm" label="期末" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.yf_qm | moneyFormat }}</span>
                    </el-table-column>
                </el-table>
            </div>
            <div class="m-b-16 flex-ac flex-sb">
                <span class="mod-title f7"
                    >合作商应收账款<span class="fs14">（{{ globalYearMonth }}_单位万）</span></span
                >
            </div>
            <div class="table-mod">
                <el-table
                    v-loading="partnerYsZjLoading"
                    :data="partnerYsZjInfo"
                    border
                    style="width: 100%;font-size: 14px"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{ color: '#3D4EFF',background: '#ffffff' }"
                    @row-click="row => ysyfRowClick('partner','ys',row.partnerName)"
                >
                    <el-table-column prop="partnerName" label="合作商名称" width="200">
                        <span class="f7" slot-scope="scope">{{ scope.row.partnerName }}</span>
                    </el-table-column>
                    <el-table-column prop="ys_qc" label="期初" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.ys_qc | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="ys_change" label="本期变动" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.ys_change | moneyFormat }}</span>
                    </el-table-column>
                    <el-table-column prop="ys_qm" label="期末" sortable>
                        <span class="f7" slot-scope="scope">{{ scope.row.ys_qm | moneyFormat }}</span>
                    </el-table-column>
                </el-table>
            </div> -->
        </div>
        <Siri
            :show-date-picker="true"
            @dateChange="globalDateChange"
            :date="globalYearMonth"
            :show-company-picker="true" 
            @companyChange="companyChange"
            :max-date="maxDate"
        />

    </div>
</template>

<script>
import utils from '../../../utils/utils';
import Siri from '../../common/dataPanel/Siri';
import Progress from '../../common/dataPanel/Progress.vue';

export default {
    name: 'companyTargetsProgress',
    data() {
        var curYearMonth = utils.getCurDate('Array')[0] + '-' + utils.getCurDate('Array')[1];
        var curYear = utils.getCurDate('Array')[0];
        return {
            loading: true,
            onlineLoading: true,
            parLoading: true,
            proLoading: true,
            deptLoading: true,

            globalYearMonth: curYearMonth,
            maxDate: `${curYear}-12`,
            curCompany: {
                id: 'ALL',
                name: '集团'
            },
            monthMlInfo:{},
            monthSaleInfo:{},
            monthZyInfo:{},
            cwsrInfo:{},
            totalMonthMlInfo:{},
            totalMonthSaleInfo:{},
            totalMonthZyInfo:{},
            taxMap:{},
            total_taxMap:{},
            jYCostInfo:{jYCostList:[]},
            totalJYCostInfo:{jYCostList:[]},

            onlineDataInfo: {},
            parDataInfo:[],
            deptDataInfo:[],
            dateType: 'month',

            companyZjData: {},
            companyZjLoading: false,
            partnerZjYfInfo: [],
            partnerZjYfLoading: false,
            partnerYsZjInfo: [],
            partnerYsZjLoading: false,
        };
    },
    components: {
        Siri, Progress
    },
    computed: {
        getYear: function() {
            return this.globalYearMonth.split('-')[0];
        },
        getMonth: function() {
            return this.globalYearMonth.split('-')[1];
        }
    },

    created() {
        this.fetchPageTypeData('month');
    },
    methods: {
        fecth() {
            this.loading = true;
            this.$http
                .post(this.$api.getCompanyMonthSaleData_new.url, {
                    yearMonth: this.globalYearMonth,
                    conpanyId: this.curCompany.id,
                    dateType: this.dateType
                })
                .then(res => {
                    this.monthMlInfo = res.data.monthMlInfo;
                    this.monthSaleInfo = res.data.monthSaleInfo;
                    this.monthZyInfo = res.data.monthZyInfo;
                    this.totalMonthMlInfo = res.data.totalMonthMlInfo;
                    this.totalMonthSaleInfo = res.data.totalMonthSaleInfo;
                    this.totalMonthZyInfo = res.data.totalMonthZyInfo;
                    this.taxMap = res.data.taxMap;
                    this.total_taxMap = res.data.total_taxMap;
                    this.jYCostInfo = res.data.jYCostInfo;
                    this.totalJYCostInfo = res.data.totalJYCostInfo;
                    this.cwsrInfo = res.data.cwsrInfo;
                    this.loading = false;
                })
                .catch(err => {});
        },
        fetchPageTypeData(dateType){
            this.dateType = dateType;
            this.fecth();
            this.fetchParMonthSaleData();
            this.fetchCompanyDeptSaleMonthData();
            // this.getCompanyZjData();
            // this.getPartnerZjYfData();
            // this.getPartnerYsZjData();
        },
        fetchParMonthSaleData() {
            this.parLoading = true;
            this.$http
                .post(this.$api.getParMonthSaleData_new.url, {
                    yearMonth: this.globalYearMonth,
                    conpanyId: this.curCompany.id,
                    dateType: this.dateType
                })
                .then(res => {
                    this.parDataInfo = res.data || null;
                    this.parLoading = false;
                })
                .catch(err => {});
        },
        fetchCompanyDeptSaleMonthData() {
            this.deptLoading = true;
            this.$http
                .post(this.$api.getCompanyDeptSaleMonthData_new.url, {
                    yearMonth: this.globalYearMonth,
                    companyId: this.curCompany.id,
                    dateType: this.dateType
                })
                .then(res => {
                    this.deptDataInfo = res.data || null;
                    this.deptLoading = false;
                })
                .catch(err => {});
        },
        getCompanyZjData() {
            this.companyZjLoading = true;
            this.$http
                .post(this.$api.getCompanyZjData.url, {
                    yearMonth: this.globalYearMonth,
                    conpanyId: this.curCompany.id,
                    dateType: this.dateType
                })
                .then(res => {
                    this.companyZjData = res.data || null;
                    this.companyZjLoading = false;
                })
                .catch(err => {});
        },
        getPartnerZjYfData() {
            this.partnerZjYfLoading = true;
            this.$http
                .post(this.$api.getPartnerZjYfData.url, {
                    yearMonth: this.globalYearMonth,
                    conpanyId: this.curCompany.id,
                    dateType: this.dateType
                })
                .then(res => {
                    this.partnerZjYfInfo = res.data || [];
                    this.partnerZjYfLoading = false;
                })
                .catch(err => {});
        },
        getPartnerYsZjData() {
            this.partnerYsZjLoading = true;
            this.$http
                .post(this.$api.getPartnerYsZjData.url, {
                    yearMonth: this.globalYearMonth,
                    conpanyId: this.curCompany.id,
                    dateType: this.dateType
                })
                .then(res => {
                    this.partnerYsZjInfo = res.data || [];
                    this.partnerYsZjLoading = false;
                })
                .catch(err => {});
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return 'warning-row';
            }
        },
        companyChange(con) {
            this.curCompany = con;
            //重载与公司相关的数据
            this.fetchPageTypeData(this.dateType);
        },
        globalDateChange(date) {
            //重载与全局时间相关的数据
            this.globalYearMonth = date;
            this.fetchPageTypeData(this.dateType);
        },
    }
};
</script>

<style lang="less">
.com-targets-progress_page {
    .el-input--suffix .el-input__inner {
        padding-right: 0;
        color: #3D4EFF;
    }
    .valid-area{
        margin-left: auto;
        margin-right: auto;
    }
    .mod-title {
        position: relative;
        font-size: 22px;
        padding-left: 12px;
        &::after {
            content: ' ';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 22px;
            background-color: #1a1a1a;
        }
    }
    .table-mod{
        padding: 24px;
        margin-bottom: 24px;
        background-color: #fff;
        border-radius: 16px;
    }
    .dis-data {
        margin-bottom: 30px;
        .com-data-item {
            width: 49%;
            padding: 24px 32px;
            background-color: #fff;
            border-radius: 16px;
            &.orange{
                background: linear-gradient(0deg, #FFFCFA 0%, #FFFFFF 100%);
            }
            &.blue{
                background: linear-gradient(0deg, #F7F8FF 0%, #FFFFFF 100%);
            }
            &.small{
                width: 32%;
            }
            &.can-click{
                cursor: pointer;
            }
            .icon{
                width: 20px;
                height: 20px;
                margin-right: 4px;
            }
            .col-half{
                width: 50%;
            }
            .col-1{
                width: 35%;
            }
            .col-2{
                width: 35%;
            }
            .col-3{
                width: 30%;
            }
        }
        .dis-info-box {
            padding: 22px 0 0;
        }
        .data-row{
            width: 50%;
            .label{
                width: 40%;
            }
            .icon-trend{
                width: 46px;
                height: 46px;
            }
        }
        .line{
            margin-top: 30px;
            margin-bottom: 20px;
            border-top: 1px solid #EBEBEB;
        }
        .zj-data{
            padding: 16px 6px;
            border-radius: 4px;
            &.purple{
                background: linear-gradient(90deg, #F7EBFF 0%, #FEFCFF 100%);
            }
            &.yellow{
                background: linear-gradient(90deg, #FFF7EB 0%, #FFFEFC 100%);
            }
        }
    }
    .fixed-rt{
        width: 100%;
        position: fixed;
        top: 88px;
        right: auto;
        left: auto;
        text-align: right;
        padding-right: 25px;
        z-index: 9;
    }
    .el-table .hlg {
        color: #E88700;
    }
    .el-table .green {
        color: #0CA867;
    }
    .el-table .warning-row {
        background: #F0F5FF;
    }
}

</style>
